import {createAsyncThunk,} from '@reduxjs/toolkit'
import {API_CONFIG} from '../app/api-config';
import {ApiLogControllerApi, GetApiLogListUsingGETRequest} from '../generated-api';

const apiLogsApi = new ApiLogControllerApi(API_CONFIG);

export const fetchApiLogsOnline = createAsyncThunk('apiLogs/list', async (filter: GetApiLogListUsingGETRequest, thunkApi) => {
    return {...await apiLogsApi.getApiLogListUsingGET(filter), filter};
});

